import { render, staticRenderFns } from "./CopyArchive.vue?vue&type=template&id=94bf4ca2&"
import script from "./CopyArchive.vue?vue&type=script&lang=js&"
export * from "./CopyArchive.vue?vue&type=script&lang=js&"
import style0 from "./CopyArchive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports